import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import { evBannerAdClick, evBannerAdView } from 'events/search';
import { trackEvent } from 'helpers/analytics';
import { track } from 'apis/amethyst';
import ImageLazyLoader from 'components/common/ImageLazyLoader';
import Tooltip from 'components/common/Tooltip';
import { MoreInfo } from 'components/icons';
import LandingPageLink from 'components/landing/LandingPageLink';
import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/search/inlineBannerAd.scss';

const InlineBannerAd = ({
  searchTerm = '',
  slotDetails: { src, link, alt, showTooltip, tooltipCopy, crossSiteSellingUniqueIdentifier }
}) => {

  const { marketplace: { shortName, hasBannerAds } } = useMartyContext();

  const handleClick = useCallback(() => {
    track(() => ([
      evBannerAdClick, { adLocation: 'SEARCH_RESULTS', searchTerm, crossSiteSellingUniqueIdentifier }
    ]));
    trackEvent('TE_BANNER_AD_CLICK', `searchTerm:${searchTerm}adLocation:RESULTS`);
  }, [crossSiteSellingUniqueIdentifier, searchTerm]);

  useEffect(() => {
    track(() => ([
      evBannerAdView, { adLocation: 'SEARCH_RESULTS', searchTerm, crossSiteSellingUniqueIdentifier }
    ]));
    trackEvent('TE_BANNER_AD_VIEW', `searchTerm:${searchTerm}adLocation:RESULTS`);
  }, [crossSiteSellingUniqueIdentifier, searchTerm]);

  if (!hasBannerAds) {
    return null;
  }

  const defaultTooltipCopy = `These are ads for products you'll find on ${shortName}.com. Clicking an ad will take you to the product's page.`;
  const imgProps = { src, alt };
  return (
    <div className={css.inlineAd}>
      <LandingPageLink url={link} className={css.innerWrapper} onClick={handleClick}>
        <ImageLazyLoader imgProps={imgProps} />
        { showTooltip &&
          <Tooltip
            content={tooltipCopy || defaultTooltipCopy}
            wrapperClassName={css.tooltipWrapper}
            tooltipClassName={css.tooltip}
            contentClassName={css.content}
            direction="down"
            tooltipId="inlineBannerAd"
          >
              Sponsored <MoreInfo className={css.icon}/>
          </Tooltip>
        }
      </LandingPageLink>
    </div>
  );
};

InlineBannerAd.contextTypes = {
  marketplace: PropTypes.object
};

export default InlineBannerAd;
